import { compose, filter, isEmpty, uniqBy } from 'lodash/fp';
import * as React from 'react';
import MediumUser from '../../../../../types/MediumUser';
import { get as getPluralized } from '../../../../react/services/Pluralize';
import r from '../../../../react/services/Replacement';
import MiniProfile from '../../MiniProfile';

type AdminListProps = {
    admins: MediumUser[];
};
const uniqActive = compose(uniqBy<MediumUser>('id'), filter<MediumUser>('isActive'));

export type AdminHelpListResolvedProps = AdminListProps & { children: (adminWording: String) => React.ReactElement };

export const AdminHelpListResolved: React.FC<AdminHelpListResolvedProps> = ({ admins, children }) => {
    const activeAdmins = uniqActive(admins);
    const adminWording = getAdminWording(activeAdmins);

    return (
        <>
            {adminWording && <div>{children(adminWording)}</div>}
            <AdminMiniProfilesList admins={activeAdmins} />
        </>
    );
};

export const AdminMiniProfilesList: React.FC<AdminListProps> = ({ admins }) => {
    if (isEmpty(admins)) {
        return null;
    }

    return (
        <div>
            <p>Here are administrators that can help you:</p>

            <ul className="nakedList">
                {admins.map(user => (
                    <li key={user.id}>
                        <MiniProfile user={user} className="round-image ui-mini-profile" />
                    </li>
                ))}
            </ul>
        </div>
    );
};

function getAdminWording(admins: Array<any>) {
    return admins.length ? `your ${getPluralized('admin', admins.length)}` : r('general.hr');
}
